import { ADMIN_RUNTIME_COMMANDS } from './adminRuntime';

/** Cloud-only compatibility port used by the shared Data & Connectivity page. */
export function createRuntimeCrawlerSettingsApi(runtime, shopId) {
  if (!runtime || runtime.productId !== 'cloud') return null;

  return Object.freeze({
    check: settings => runtime.sendMessageWithResponse(
      ADMIN_RUNTIME_COMMANDS.CRAWLER_CONNECTIVITY_CHECK,
      { shopId, settings },
    ),
    save: settings => runtime.sendMessageWithResponse(
      ADMIN_RUNTIME_COMMANDS.CRAWLER_SETTINGS_SAVE,
      { shopId, settings },
    ),
  });
}
